/**
 * Custom smooth scroll function with controllable duration.
 * Uses requestAnimationFrame for a smooth animation loop.
 *
 * @param {number} targetPosition The final vertical position to scroll to.
 * @param {number} duration The duration of the scroll animation in milliseconds.
 */
export const smoothScrollTo = (targetPosition, duration = 800) => {
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    
    // Use an easing function for a more natural acceleration/deceleration effect
    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    
    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };

  /**
   * Easing function: ease-in-out quadratic
   * @param {number} t - current time
   * @param {number} b - start value
   * @param {number} c - change in value
   * @param {number} d - duration
   */
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  requestAnimationFrame(animation);
};
